//export const apiURI = "https://localhost:32780"
// TODO - Move this to an environment variable
//export const apiURI = "https://smartai-stockimage-api-service-master-us-east1-3vbtmsim5q-ue.a.run.app";
export const apiURI = "https://smartai-stockimage-api-qa-us-east1-1090515615638.us-east1.run.app";
